export default __webpack_public_path__ + "static/media/99vu2WvgDUc-HD.adc53b54.jpg";